import React from "react";
import RequestsTable from "./WithDrawRequestsTable";
import { TWithdrawRequest } from "@/redux/feature/balaneWithdraw/balanceWithdrawTypes";

const WithdrawRequestTable = ({ data }: { data: TWithdrawRequest[] }) => {
  return (
    <div>
      <RequestsTable data={data} />
    </div>
  );
};

export default WithdrawRequestTable;
